import { AllocationScenarioValuationModel } from 'api';
import { ValuationsApproach } from 'common/types/valuation';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { EquityAllocationCellCustomData } from 'pages/ValuationsAllocation/allocation/EquityAllocation/config';
import {
  OnChangeType,
  UpdateAllocationScenariosWithRelated,
  UpdateOPMInputsParams,
} from 'pages/ValuationsAllocation/hooks/useEquityAllocationInputHandlers/types';
import { isMaturityCell } from 'pages/ValuationsAllocation/util/cellValidators';

interface HandleMaturityParams {
  cell: ICell<EquityAllocationCellCustomData>;
  allocationScenarios: AllocationScenarioValuationModel[];
  approaches: ValuationsApproach[];
  cells: any;
  onChange: OnChangeType;
  updateAllocationScenariosWithRelated: UpdateAllocationScenariosWithRelated;
  updateOPMInputs: (params: UpdateOPMInputsParams) => Promise<void>;
}

/**
 * Handles changes to maturity cells in the equity allocation sheet.
 * Recalculates risk-free rates and updates allocation scenarios.
 */
export const handleMaturity = async (params: HandleMaturityParams): Promise<void> => {
  const {
    cell,
    allocationScenarios,
    approaches,
    cells,
    onChange,
    updateAllocationScenariosWithRelated,
    updateOPMInputs,
  } = params;

  if (!isMaturityCell(cell)) {
    return;
  }

  // Update Risk Free Rates based on OPM Inputs
  await updateOPMInputs({
    allocationScenarios,
    approaches,
  });

  await updateAllocationScenariosWithRelated(
    {
      allocationScenarios,
      approaches,
    },
    cells,
    onChange
  );
};
